import PropTypes from "prop-types"
import React from "react"

import AlertBanner from "src/components/AlertBanner"

const CashAgreement = ({ copy }) => (
  <AlertBanner type="info" title={copy.cashAgreementTitle}>
    {copy.cashAgreementBody}
  </AlertBanner>
)

CashAgreement.propTypes = {
  copy: PropTypes.shape({
    cashAgreementBody: PropTypes.string,
    cashAgreementTitle: PropTypes.string,
  }).isRequired,
}

export default CashAgreement
